// removed by extract-text-webpack-plugin
module.exports = {"container":"xFU8kdpVXUzLakcuQW4Ew","iconStyle":"Y2NYcBZo1HrN9OPcQFTkx"};


//////////////////
// WEBPACK FOOTER
// ../components/social/styles.module.css
// module id = 606
// module chunks = 0